export const METER_TROUBLESHOOTING_ARTICLE_URL =
  'https://support.clipsalcortex.com/hc/en-us/articles/7245710193295-Cortex-meter-Connection-error';

export const HYBRID_INVERTER_TROUBLESHOOTING_ARTICLE_URL =
  'https://support.clipsalcortex.com/hc/en-us/articles/7245912920847-Hybrid-inverter-No-communication-GoodWe-and-LG-';
